import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import TableWithoutPagination from "../Table/TableWithoutPagination";
import AnalyseRisquesStatusIcon from "./AnalyseRisquesStatusIcon";
import { checkAndImportFromOpenErp } from "../../redux/analyseRisques/analyseRisquesEditionActions";
import Icon from "@mui/material/Icon/Icon";
import Button from "@mui/material/Button/Button";
import { loadSubcontractors } from "../../redux/tiers/tiersActions";
import "./SearchTable.css";

class SearchTable extends Component {
    constructor(props) {
        super(props);

        let title = "Analyses de risques";

        if (props.moduleSpp) title = "Plans de prévention simplifiés";

        this.state = {
            searchAnalyseRisqueInput: "",
            columns: [
                {
                    Header: title,
                    columns: [
                        {
                            Header: "Statut",
                            id: "status",
                            filterable: false,
                            width: 100,
                            Cell: ({ row }) => {
                                let currentAnalyseRisques =
                                    this.props.partialSpp[row.index];
        
                                if (!currentAnalyseRisques) return null;
        
                                return (
                                    <div className="margin-status-icon">
                                        <AnalyseRisquesStatusIcon
                                            status={currentAnalyseRisques.state}
                                        />
                                    </div>
                                );
                            },
                        },
                        {
                            Header: "Code",
                            id: "code",
                            accessor: (a) => a.name,
                        },
                        {
                            Header: "Client",
                            id: "customer",
                            accessor: (a) =>
                                a.customer_id
                                    ? a.customer_id[1]
                                    : a.customer_ref_tablet
                                    ? a.customer_ref_tablet
                                    : "",
                        },
                        {
                            Header: "Affaire/OT",
                            id: "affair",
                            accessor: (a) => {
                                if (a.affair_id) return a.affair_id[1];
        
                                if (a.work_order_id) return a.work_order_id[1];
        
                                return "";
                            },
                        },
                        {
                            Header: "Agence",
                            id: "company",
                            accessor: (a) =>
                                a.company_id ? a.company_id[1] : "",
                        },
                        {
                            Header: "Nature et localisation",
                            id: "nature_and_location",
                            accessor: (a) => a.nature_and_location,
                        },
                        {
                            Header: "Importer",
                            id: "import",
                            width: 50,
                            Cell: this.renderButtons.bind(this),
                        },                        
                    ],
                },                
            ],
        };

        this.props.loadSubcontractors();
    }

    import(row) {
        this.props.importFromOpenErp(
            row,
            this.props.moduleSpp,
            this.props.activeUser,
            this.props.analysesRisques,
            this.props.subcontractors
        );
    }

    renderButtons(row) {
        return (
            <div className="solution-table-row-padding">
                <Button
                    onClick={this.import.bind(this, row)}
                    className="col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin"
                    color="primary"
                >
                    <Icon className="small-icon">get_app</Icon>
                </Button>
            </div>
        );
    }

    getTableTrProps(row) {
        if (row) {
            return {
                onClick: this.import.bind(this, row.original),
                style: {
                    cursor: "pointer",
                },
            };
        } else {
            return {};
        }
    }

    render() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding analyse-risques-table">
                    <TableWithoutPagination
                        filterable
                        data={this.props.partialSpp}
                        columns={this.state.columns}
                        getTrProps={this.getTableTrProps.bind(this)}
                        className="tableWithoutPaginationCustomClass"
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        analysesRisques: state.analysesRisques.analysesRisques,
        partialSpp: state.analysesRisques.partialSpp,
        moduleSpp: state.analysesRisques.moduleSpp,
        activeUser: state.activeUser,
        subcontractors: state.tiers.subcontractors,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        importFromOpenErp: (
            partialAr,
            moduleSpp,
            user,
            analysesRisquesState,
            subcontractors
        ) =>
            dispatch(
                checkAndImportFromOpenErp(
                    partialAr,
                    moduleSpp,
                    user,
                    analysesRisquesState,
                    subcontractors
                )
            ),
        loadSubcontractors: () => dispatch(loadSubcontractors()),
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(SearchTable);
